//to extract file name from a given URL
export function extractFileName(url) {
  try {
    const pathname = new URL(url).pathname;
    return pathname.substring(pathname.lastIndexOf("/") + 1);
  } catch {
    return url.split("/").pop()?.split("?")[0] || "";
  }
}
